import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

function TableRowPerAction({
  onEdit,
  onDelete,
  onToggle,
  initialToggle = false,
}) {
  const [isOn, setIsOn] = useState(initialToggle);

  const handleToggle = (e) => {
    e.stopPropagation();
    const newState = !isOn;
    setIsOn(newState);
    if (onToggle) onToggle(newState);
  };
  return (
    <td
      className={`absolute flex gap-3 mr-1 ml-2 mr-2 right-10 transform opacity-0 group-hover:opacity-100 z-10 transition-opacity duration-300 bg-gray-100`}
    >
      {onEdit && (
        <button
          className={`text-primary px-2 py-1 rounded-[8px] hover:scale-105`}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          <FontAwesomeIcon icon={faEdit} className="mt-1" />
        </button>
      )}
      {onDelete && (
        <button
          className={`text-primary px-2 py-1 rounded-[8px] hover:scale-105`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} className="mt-1 text-red-500" />
        </button>
      )}
      {onToggle && (
        <button
          onClick={handleToggle}
          className={`mt-1 relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
            isOn ? "bg-green-500" : "bg-gray-300"
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
              isOn ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      )}
    </td>
  );
}

export default TableRowPerAction;
